module.exports = __webpack_public_path__ + "img/down_arrow.72e387a2-d4fc992a.99952dfe.svg";